import axios from '@/services'
import { defineStore } from 'pinia'

export const useOcrStore = defineStore('ocr', {
  state: () => {
    return {
      ocrType: null,
      uploadedFile: null,
      ocrResponse: null,
      operationType: null // 'scanning' | 'capturing'
    }
  },
  getters: {},
  actions: {
    async uploadDocument() {
      try {
        const regex = /^data:image\/\w{3,4};base64,/
        const base64Image = this.uploadedFile.replace(regex, '')
        const payload = {
          type: this.ocrType,
          base64Image
        }

        const { data } = await axios.post('/api/ocr/info', payload, {
          preventLoadingAnimation: true
        })
        this.ocrResponse = data
      } catch (error) {
        throw new Error()
      }
    }
  }
})
